export const viContent = {
  introduction: {
    content: [
      "Kể từ khi ra mắt vào năm 1996, loạt Pokémon đã chinh phục trái tim của người chơi trên toàn thế giới và trở thành một trong những thương hiệu giải trí phổ biến nhất. Trình Tạo Pokémon Ngẫu Nhiên của chúng tôi được thiết kế cho các huấn luyện viên ở mọi lứa tuổi, dù bạn muốn khám phá những Pokémon mới, xây dựng đội hình cân bằng, hay chỉ đơn giản là tận hưởng những bất ngờ trong hành trình Pokémon của mình.",
      "Dù bạn là người chơi có kinh nghiệm đang tìm kiếm cảm hứng cho trận đấu tiếp theo hay người chơi bình thường muốn mở rộng Pokédex của mình, công cụ tạo Pokémon ngẫu nhiên này sẽ cung cấp cho bạn một cách thú vị và tương tác để khám phá thế giới Pokémon rộng lớn."
    ]
  },
  howToUse: {
    content: [
      "Sử dụng trình chọn Pokémon ngẫu nhiên của chúng tôi rất đơn giản và trực quan. Hãy làm theo các bước sau để bắt đầu tạo đội hình Pokémon hoàn hảo của bạn:",
      {
        type: "orderedList",
        items: [
          { type: "text", content: "Chọn số lượng Pokémon: Xác định số lượng Pokémon bạn muốn tạo (1-8)." },
          { type: "text", content: "Chọn hệ: Lọc các hệ Pokémon cụ thể như Lửa, Nước, Điện, v.v., hoặc chọn \"Bất kỳ\" để bao gồm tất cả các hệ." },
          { type: "text", content: "Chọn thế hệ: Chọn từ thế hệ thứ nhất đến thứ tám, hoặc chọn \"Bất kỳ\" để bao gồm Pokémon từ tất cả các thế hệ." },
          { type: "text", content: "Thiết lập độ hiếm: Xác định mức độ hiếm của Pokémon được tạo." },
          { type: "text", content: "Nhấp \"Tạo\": Sau khi thiết lập tùy chọn, nhấp nút để tạo Pokémon." },
          { type: "text", content: "Khám phá kết quả: Xem thông tin chi tiết về mỗi Pokémon, bao gồm chỉ số cơ bản, khả năng, hệ và nhiều hơn nữa!" }
        ]
      },
      "Bạn có thể điều chỉnh các thông số bất cứ lúc nào và thử nhiều lần để khám phá các kết hợp Pokémon khác nhau."
    ]
  },
  benefits: {
    content: [
      {
        type: "unorderedList",
        items: [
          { type: "text", content: "Hoàn toàn miễn phí: Trình tạo Pokémon ngẫu nhiên của chúng tôi hoàn toàn miễn phí để sử dụng, không có phí ẩn hoặc yêu cầu đăng ký." },
          { type: "text", content: "Trải nghiệm tùy chỉnh: Tùy chỉnh lựa chọn ngẫu nhiên của bạn dựa trên hệ, thế hệ và độ hiếm." },
          { type: "text", content: "Công cụ giáo dục: Tìm hiểu về chỉ số cơ bản, khả năng và hệ của các Pokémon khác nhau." },
          { type: "text", content: "Trợ lý xây dựng đội hình: Nhanh chóng tạo đội hình cân bằng cho các trận đấu thông thường hoặc thi đấu." },
          { type: "text", content: "Tạo thử thách: Tạo các thử thách chơi game độc đáo bằng cách giới hạn bản thân với Pokémon được tạo ngẫu nhiên." },
          { type: "text", content: "Không cần tài khoản: Bắt đầu sử dụng công cụ ngay lập tức mà không cần đăng ký hoặc cung cấp thông tin cá nhân." }
        ]
      }
    ]
  },
  history: {
    content: [
      "Loạt Pokémon bắt đầu vào năm 1996 khi Satoshi Tajiri tạo ra trò chơi đầu tiên cho Nintendo Game Boy. Lấy cảm hứng từ sở thích sưu tập côn trùng thời thơ ấu của mình, khái niệm xoay quanh việc bắt, huấn luyện và chiến đấu với những sinh vật được gọi là \"Pocket Monsters\" hay Pokémon.",
      "Những cột mốc quan trọng trong lịch sử Pokémon bao gồm:",
      {
        type: "unorderedList",
        items: [
          { type: "text", content: "1996: Ra mắt trò chơi gốc Pokémon Red và Green tại Nhật Bản" },
          { type: "text", content: "1998: Phát hành quốc tế Pokémon Red và Blue" },
          { type: "text", content: "1999: Ra mắt toàn cầu trò chơi thẻ bài Pokémon" },
          { type: "text", content: "2000: Phát hành Pokémon Gold và Silver với 100 Pokémon mới" },
          { type: "text", content: "2016: Ra mắt Pokémon GO, đưa loạt game lên nền tảng di động" },
          { type: "text", content: "2019: Phát hành Pokémon Sword và Shield trên Nintendo Switch" }
        ]
      },
      "Ngày nay, với hơn 900 Pokémon khác nhau qua tám thế hệ, loạt game đã mở rộng bao gồm trò chơi điện tử, trò chơi thẻ bài, phim hoạt hình, phim điện ảnh, hàng hóa và ứng dụng di động, trở thành một trong những thương hiệu truyền thông có lợi nhuận cao nhất mọi thời đại."
    ]
  },
  popularPokemon: {
    content: [
      "Trong lịch sử Pokémon, một số Pokémon đã trở thành biểu tượng mang tính biểu tượng của loạt game:",
      {
        type: "unorderedList",
        items: [
          { type: "text", content: "Pikachu: Linh vật hệ Điện của loạt game, nổi tiếng với cái đuôi hình tia chớp và má đỏ." },
          { type: "text", content: "Charizard: Pokémon hệ Lửa/Bay yêu thích của người hâm mộ, nổi tiếng với vẻ ngoài giống rồng và sức mạnh." },
          { type: "text", content: "Mewtwo: Pokémon huyền thoại hệ Tâm Linh được tạo ra thông qua thao tác gen từ Mew, nổi tiếng với sức mạnh phi thường." },
          { type: "text", content: "Eevee: Được yêu thích vì khả năng tiến hóa độc đáo thành nhiều hình thái, bao gồm Vaporeon, Jolteon và Flareon." },
          { type: "text", content: "Gyarados: Pokémon hệ Nước/Bay mạnh mẽ tiến hóa từ Magikarp yếu ớt." },
          { type: "text", content: "Lucario: Pokémon hệ Chiến Đấu/Thép, nổi tiếng với sức mạnh aura và sự phổ biến trong các trận đấu thi đấu." },
          { type: "text", content: "Greninja: Pokémon ninja hệ Nước/Bóng Tối đạt được sự nổi tiếng thông qua loạt phim hoạt hình." }
        ]
      },
      "Trình tạo Pokémon ngẫu nhiên của chúng tôi cho bạn cơ hội khám phá những loài mang tính biểu tượng này, cũng như nhiều loài khác cũng thú vị nhưng ít được biết đến hơn."
    ]
  },
  popularGames: {
    content: [
      "Loạt game Pokémon đã phát hành nhiều tựa game phổ biến trên các nền tảng khác nhau:",
      {
        type: "unorderedList",
        items: [
          { type: "text", content: "Pokémon Red, Blue và Yellow: Những trò chơi gốc bắt đầu huyền thoại trên Game Boy." },
          { type: "text", content: "Pokémon Gold, Silver và Crystal: Giới thiệu vùng Johto và hệ thống ngày đêm." },
          { type: "text", content: "Pokémon Ruby, Sapphire và Emerald: Mở rộng thế giới game với vùng Hoenn và trận đấu đôi." },
          { type: "text", content: "Pokémon Diamond, Pearl và Platinum: Đưa loạt game lên Nintendo DS với tính năng trực tuyến." },
          { type: "text", content: "Pokémon Black và White: Giới thiệu dàn Pokémon hoàn toàn mới với trọng tâm vào cốt truyện." },
          { type: "text", content: "Pokémon X và Y: Giới thiệu mô hình 3D và Mega Tiến Hóa." },
          { type: "text", content: "Pokémon Sun và Moon: Tái thiết kế hệ thống gym với thử thách đảo." },
          { type: "text", content: "Pokémon GO: Trò chơi di động thực tế ảo trở thành hiện tượng toàn cầu." },
          { type: "text", content: "Pokémon Sword và Shield: Đưa loạt game lên Nintendo Switch với khái niệm Vùng Hoang Dã." },
          { type: "text", content: "Pokémon Legends: Arceus: Nỗ lực đầu tiên của loạt game trong thể loại thế giới mở." }
        ]
      },
      "Mỗi trò chơi giới thiệu cơ chế và Pokémon mới, mở rộng thế giới Pokémon có thể khám phá thông qua trình tạo Pokémon ngẫu nhiên của chúng tôi."
    ]
  },
  tradingContests: {
    content: [
      "Trao đổi Pokémon đã là tính năng cơ bản của loạt game từ đầu. Các trò chơi gốc được phát hành theo cặp đặc biệt để khuyến khích trao đổi Pokémon giữa bạn bè để hoàn thành Pokédex. Yếu tố xã hội này đã giúp lan truyền sự phổ biến của Pokémon và vẫn quan trọng cho đến ngày nay.",
      "Các khía cạnh chính của việc trao đổi bao gồm:",
      {
        type: "unorderedList",
        items: [
          { type: "text", content: "Pokémon độc quyền phiên bản chỉ có thể có được thông qua trao đổi" },
          { type: "text", content: "Một số Pokémon như Machamp và Gengar chỉ tiến hóa thông qua trao đổi" },
          { type: "text", content: "Hệ thống Trao đổi Toàn cầu (GTS) trong các trò chơi hiện đại cho phép trao đổi trên toàn thế giới" },
          { type: "text", content: "Trao đổi Pokémon hiếm hoặc shiny như một biểu tượng địa vị" }
        ]
      },
      "Cuộc thi Pokémon, được giới thiệu ở thế hệ thứ ba, cung cấp một cách thức cạnh tranh thay thế nơi Pokémon cạnh tranh dựa trên ngoại hình, biểu diễn và sự quyến rũ thay vì sức mạnh chiến đấu. Những cuộc thi này bao gồm:",
      {
        type: "unorderedList",
        items: [
          { type: "text", content: "Các hạng mục thi đấu khác nhau (Mát mẻ, Đẹp, Dễ thương, Thông minh, Mạnh mẽ)" },
          { type: "text", content: "Các động tác được thiết kế đặc biệt cho cuộc thi" },
          { type: "text", content: "Quản lý tình trạng Pokémon thông qua Berry và Poffin" },
          { type: "text", content: "Cuộc thi nhiều giai đoạn với đánh giá hình ảnh sơ bộ và vòng biểu diễn" }
        ]
      },
      "Trình tạo Pokémon ngẫu nhiên của chúng tôi có thể giúp bạn khám phá những Pokémon xuất sắc trong các cuộc thi hoặc trở thành đối tác trao đổi có giá trị, thêm một chiều kích mới cho trải nghiệm Pokémon của bạn."
    ]
  },
  faq: {
    content: [
      {
        type: "faqList",
        items: [
          { 
            type: "faq",
            question: "Trình tạo Pokémon ngẫu nhiên này có miễn phí không?",
            answer: "Có, công cụ của chúng tôi hoàn toàn miễn phí để sử dụng, không có phí ẩn hoặc yêu cầu đăng ký."
          },
          {
            type: "faq",
            question: "Dữ liệu Pokémon chính xác đến mức nào?",
            answer: "Tất cả dữ liệu Pokémon đến từ PokéAPI chính thức, đảm bảo độ chính xác và cập nhật kịp thời."
          },
          {
            type: "faq",
            question: "Tôi có thể tạo Pokémon từ thế hệ cụ thể không?",
            answer: "Có, bạn có thể chọn bất kỳ thế hệ nào từ thứ nhất đến thứ tám, hoặc chọn \"Bất kỳ\" để bao gồm tất cả các thế hệ."
          },
          {
            type: "faq",
            question: "Bộ lọc độ hiếm hoạt động như thế nào?",
            answer: "Thuật toán của chúng tôi gán giá trị độ hiếm 1-10 cho mỗi Pokémon dựa trên trạng thái huyền thoại/thần thoại, kinh nghiệm cơ bản và các yếu tố khác."
          },
          {
            type: "faq",
            question: "Tôi có thể lưu hoặc xuất Pokémon đã tạo không?",
            answer: "Hiện tại, bạn có thể chụp ảnh màn hình kết quả. Chúng tôi đang xem xét thêm tính năng lưu/xuất trong các bản cập nhật sắp tới."
          },
          {
            type: "faq",
            question: "Trình tạo Pokémon ngẫu nhiên có hỗ trợ thiết bị di động không?",
            answer: "Có, trình tạo của chúng tôi hoàn toàn hỗ trợ thiết kế đáp ứng và có thể được sử dụng trên điện thoại thông minh, máy tính bảng và máy tính."
          }
        ]
      }
    ]
  },
  conclusion: {
    content: [
      "Trình tạo Pokémon ngẫu nhiên của chúng tôi cung cấp khả năng vô tận cho cả người chơi bình thường và huấn luyện viên chuyên nghiệp. Cho dù bạn muốn khám phá những yêu thích mới, tạo đội hình theo chủ đề, hay thách thức bản thân với những kết hợp bất ngờ, công cụ của chúng tôi cung cấp một cách thú vị và giáo dục để khám phá thế giới Pokémon rộng lớn.",
      "Chúng tôi liên tục làm việc để cải thiện trình tạo, thêm tính năng và tùy chọn mới. Hãy thử thiết lập tùy chọn của bạn và nhấp \"Tạo\" ngay bây giờ để xem bạn sẽ gặp những Pokémon nào!",
      "Chia sẻ kết quả của bạn với bạn bè và các huấn luyện viên khác, cho chúng tôi biết bạn sử dụng trình tạo Pokémon ngẫu nhiên như thế nào trong hành trình Pokémon của mình. Chúc khám phá vui vẻ!"
    ]
  }
}; 